/* 运营统计分析模块路由 */
// import Main from '@/view/main'
export default {
  path: 'sa',
  meta: {
    title: '统计分析'
  },
  component: () => import('@/components/parent-view'),
  name: 'sa',
  children: [
    {
      path: 'product',
      name: 'product-statistics',
      meta: {
        title: '商品统计'
      },
      component: () => import('@/view/sa/product')
    },
    {
      path: 'merchant',
      name: 'merchant-enquiry',
      meta: {
        title: '商户订单查询'
      },
      component: () => import('@/view/sa/merchant/list')
    },
    {
      path: 'merchant/order/:id',
      name: 'merchant-enquiry-order',
      meta: {
        title: '商户订单详情'
      },
      component: () => import('@/view/sa/merchant/order')
    },
    {
      path: 'merchant/delivery/:id',
      name: 'merchant-enquiry-delivery',
      meta: {
        title: '送货单详情'
      },
      component: () => import('@/view/sa/merchant/delivery')
    }
    // {
    //   path: 'audit',
    //   name: 'tender-audit',
    //   meta: {
    //     title: '标书审核'
    //   },
    //   component: () => import('@/view/tender/audit')
    // },
    // {
    //   path: 'audit/detail',
    //   name: 'tender-detail',
    //   meta: {
    //     title: '标书审核详情',
    //     hideInTabBar: true
    //   },
    //   component: () => import('@/view/tender/audit/detail.vue')
    // },
    // {
    //   path: 'query',
    //   meta: {
    //     title: '标书查询'
    //   },
    //   component: () => import('@/components/parent-view'),
    //   children: [
    //     {
    //       path: '',
    //       name: 'tender-query',
    //       meta: {
    //         title: '标书查询',
    //         ignoreBreadCrumb: true
    //       },
    //       component: () => import('@/view/tender/query')
    //     },
    //     {
    //       path: 'detail/:id',
    //       name: 'tender-query-detail',
    //       meta: {
    //         title: '投标详情',
    //         notCache: true
    //       },
    //       component: () => import('@/view/tender/query/detail.vue')
    //     }
    //   ]
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/sa.js